<template>
  <div class="container-fluid">
    <div class="card-header card-custom-brown" slot="card_title">
      <i class="fas fa-cubes"></i> Cotation panier
    </div>
    <form @submit.prevent="send" @keydown="form.onKeydown($event)">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-brown">
            <div class="box-body">
              <div class="row d-flex justify-content-center mt-3">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="client"
                      >Client <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      :value="user.nom"
                      id="client"
                      name="client"
                      placeholder="Client"
                      disabled
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label for="date"
                      >Date <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      :class="{ 'is-invalid': form.errors.has('date') }"
                      v-model="form.date"
                      id="date"
                      name="date"
                      v-input-mask
                      data-inputmask-alias="datetime"
                      data-inputmask-inputformat="dd/mm/yyyy"
                      placeholder="Date"
                      required
                    />
                    <has-error :form="form" field="date"></has-error>
                  </div>
                </div>

                <!-- <div class="col-md-2">
                  <div class="form-group" style="padding-top: 5px;">
                    <div class="custom-control custom-checkbox mt-4">
                      <input
                              type="checkbox"
                              class="custom-control-input"
                              v-model="form.brouillon"
                              id="brouillon"
                              name="brouillon"
                              value="1"
                      />
                      <label class="custom-control-label pt-0" for="brouillon"
                      >Brouillon</label
                      >
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-12">
          <div class="box box-brown">
            <div class="box-body">
              <div class="row justify-content-center">
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control form-control-md"
                    id="recherche"
                    name="recherche"
                    placeholder="Rechercher article"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div
            id="alert"
            v-if="errorTableau === true"
            class="alert alert-danger alert-dismissible"
            style="vertical-align: middle"
          >
            <button
              type="button"
              class="close alert-close"
              id="alert-close"
              @click="errorTableau = !errorTableau"
            >
              &times;
            </button>
            <p v-text="errorTableauMessage"></p>
          </div>

          <div class="box box-primary">
            <div class="box-body table-responsive">
              <table
                id="line-table"
                class="line-table table table-condensed table-striped table-bordered table-hover w-100 mt-3"
              >
                <thead class="label-info text-white">
                  <tr v-if="Number(user.prix) === 0 && Number(assujjeti) === 0">
                    <th class="col-sm-10" style="font-weight: bold">Article</th>
                    <th class="col-sm-2" style="font-weight: bold">Quantité</th>
                    <th style="font-weight: bold">Action</th>
                  </tr>
                  <tr
                    v-else-if="
                      Number(user.prix) === 0 && Number(assujjeti) === 1
                    "
                  >
                    <th class="col-sm-8" style="font-weight: bold">Article</th>
                    <th class="col-sm-2" style="font-weight: bold">Quantité</th>
                    <th class="col-sm-2" style="font-weight: bold">TVA %</th>
                    <th style="font-weight: bold">Action</th>
                  </tr>
                  <tr
                    v-else-if="
                      Number(user.prix) === 1 && Number(assujjeti) === 0
                    "
                  >
                    <th class="col-sm-7" style="font-weight: bold">Article</th>
                    <th class="col-sm-1" style="font-weight: bold">Quantité</th>
                    <th class="col-sm-2" style="font-weight: bold">
                      Prix U HT
                    </th>
                    <th class="col-sm-2" style="font-weight: bold">Montant</th>
                    <th style="font-weight: bold">Action</th>
                  </tr>
                  <tr
                    v-else-if="
                      Number(user.prix) === 1 && Number(assujjeti) === 1
                    "
                  >
                    <th class="col-sm-6" style="font-weight: bold">Article</th>
                    <th class="col-sm-1" style="font-weight: bold">Quantité</th>
                    <th class="col-sm-2" style="font-weight: bold">
                      Prix U HT
                    </th>
                    <th class="col-sm-1" style="font-weight: bold">TVA %</th>
                    <th class="col-sm-2" style="font-weight: bold">Montant</th>
                    <th style="font-weight: bold">Action</th>
                  </tr>
                </thead>
                <tbody
                  v-if="Number(user.prix) === 0 && Number(assujjeti) === 0"
                >
                  <tr v-for="(item, key) in items" v-bind:key="key">
                    <td style="vertical-align: middle">
                      {{
                        JSON.parse(item.article_libelle)[locale]
                          ? JSON.parse(item.article_libelle)[locale]
                          : "###"
                      }}
                    </td>
                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.quantite"
                        placeholder="Quantité"
                        @focus="$event.target.select()"
                        required
                      />
                    </td>
                    <td style="vertical-align: middle">
                      <button
                        type="button"
                        class="btn btn-danger btn-xs remove removeLine text-white"
                        :id="'removeLine' + key"
                        @click="removeItem(key)"
                      >
                        <span class="fa fa-minus"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-else-if="Number(user.prix) === 0 && Number(assujjeti) === 1"
                >
                  <tr v-for="(item, key) in items" v-bind:key="key">
                    <td style="vertical-align: middle">
                      {{
                        JSON.parse(item.article_libelle)[locale]
                          ? JSON.parse(item.article_libelle)[locale]
                          : "###"
                      }}
                    </td>
                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.quantite"
                        placeholder="Quantité"
                        @focus="$event.target.select()"
                        required
                      />
                    </td>

                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.tva"
                        placeholder="TVA"
                        @focus="$event.target.select()"
                        disabled
                      />
                    </td>

                    <td style="vertical-align: middle">
                      <button
                        type="button"
                        class="btn btn-danger btn-xs remove removeLine text-white"
                        :id="'removeLine' + key"
                        @click="removeItem(key)"
                      >
                        <span class="fa fa-minus"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-else-if="Number(user.prix) === 1 && Number(assujjeti) === 0"
                >
                  <tr v-for="(item, key) in items" v-bind:key="key">
                    <td style="vertical-align: middle">
                      {{
                        JSON.parse(item.article_libelle)[locale]
                          ? JSON.parse(item.article_libelle)[locale]
                          : "###"
                      }}
                    </td>
                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.quantite"
                        placeholder="Quantité"
                        @focus="$event.target.select()"
                        required
                      />
                    </td>
                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.prix"
                        placeholder="Prix U HT"
                        @focus="$event.target.select()"
                        disabled
                      />
                    </td>

                    <td style="vertical-align: middle" class="text-right">
                      <b>{{
                        (item.prix * item.quantite +
                          (item.prix * item.quantite * item.tva) / 100)
                          | currency
                      }}</b>
                    </td>

                    <td style="vertical-align: middle">
                      <button
                        type="button"
                        class="btn btn-danger btn-xs remove removeLine text-white"
                        :id="'removeLine' + key"
                        @click="removeItem(key)"
                      >
                        <span class="fa fa-minus"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-else-if="Number(user.prix) === 1 && Number(assujjeti) === 1"
                >
                  <tr v-for="(item, key) in items" v-bind:key="key">
                    <td style="vertical-align: middle">
                      {{
                        JSON.parse(item.article_libelle)[locale]
                          ? JSON.parse(item.article_libelle)[locale]
                          : "###"
                      }}
                    </td>
                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.quantite"
                        placeholder="Quantité"
                        @focus="$event.target.select()"
                        required
                      />
                    </td>
                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.prix"
                        placeholder="Prix U HT"
                        @focus="$event.target.select()"
                        disabled
                      />
                    </td>

                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.tva"
                        placeholder="TVA"
                        @focus="$event.target.select()"
                        disabled
                      />
                    </td>

                    <td style="vertical-align: middle" class="text-right">
                      <b>{{
                        (item.prix * item.quantite +
                          (item.prix * item.quantite * item.tva) / 100)
                          | currency
                      }}</b>
                    </td>

                    <td style="vertical-align: middle">
                      <button
                        type="button"
                        class="btn btn-danger btn-xs remove removeLine text-white"
                        id="removeLine"
                        @click="removeItem(key)"
                      >
                        <span class="fa fa-minus"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot v-if="items.length > 0" class="footerTotal">
                  <tr v-if="Number(user.prix) === 0 && Number(assujjeti) === 0">
                    <td colspan="3" style="text-align: right">
                      {{ items.length + " Article(s)" }}
                    </td>
                  </tr>
                  <tr
                    v-else-if="
                      Number(user.prix) === 0 && Number(assujjeti) === 1
                    "
                  >
                    <td colspan="4" style="text-align: right">
                      {{ items.length + " Article(s)" }}
                    </td>
                  </tr>
                  <tr
                    v-else-if="
                      Number(user.prix) === 1 && Number(assujjeti) === 0
                    "
                  >
                    <td colspan="1" style="text-align: right">TOTAL</td>
                    <td colspan="4" class="text-right">
                      {{ total | currency }}
                    </td>
                  </tr>
                  <tr
                    v-else-if="
                      Number(user.prix) === 1 && Number(assujjeti) === 1
                    "
                  >
                    <td colspan="1" style="text-align: right">TOTAL</td>
                    <td colspan="5" class="text-right">
                      {{ total | currency }}
                    </td>
                  </tr>
                </tfoot>
              </table>
              <div v-if="items.length <= 0" class="text-center h4 text-muted">
                Votre panier est vide pour l'instant !
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-right">
          <ButtonLoader
            :busy="form.busy"
            type="submit"
            classes="btn-send"
            loadText="Traitement en cours..."
            Text="Envoyer"
          ></ButtonLoader>

          <ButtonLoader
            :busy="form.busy"
            type="button"
            @btn-click="save"
            classes="btn-save"
            loadText="Traitement en cours..."
            Text="Enregistrer"
          ></ButtonLoader>

          <!-- <router-link
            :to="{ name: 'shop' }"
            class="link-all-articles"
          >
            Liste des articles
          </router-link> -->
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import * as services from "./service/services";
//import { CoolSelect } from 'vue-cool-select';
//import 'vue-cool-select/dist/themes/bootstrap.css'
import Form from "vform";

export default {
  name: "CotationPanierCreate",
  data: function () {
    return {
      form: new Form({
        client: "",
        date: "",
        brouillon: false,
        itemList: [],
      }),

      errorTableau: false,
      errorTableauMessage: "",

      title: "Cotation - Création",
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + " | %s",
    };
  },
  computed: {
    total: function () {
      return _.sum(
        this.items.map(
          (item) =>
            item.quantite * item.prix +
            (item.quantite * item.prix * item.tva) / 100
        )
      );
    },
    assujjeti: function () {
      return this.$store.getters["auth/userp"].assujetti_tva;
    },
    user() {
      return this.$store.getters["auth/userp"];
    },
    items: {
      get() {
        return this.$store.getters["cotation/currentCotation"].items;
      },
      set(value) {
        this.$store.dispatch("cotation/setCotation", { items: items });
      },
    },
    locale() {
      return this.$store.getters["configapp/locale"];
    },
    tva() {
      return this.$store.getters["configapp/tva"];
    },
  },
  methods: {
    addItem: function (select) {
      let self = this;

      if (select && self.user.uuid) {
        var objExiste = _.find(self.items, (o) => o.article === select.uuid);
        if (!objExiste) {
          let item = {
            article: select.uuid,
            article_libelle: select.designation,
            unite: select.unite_uuid,
            unite_libelle: select.unite,
            prix: select.prix_vente_mru,
            tva: self.assujjeti === 1 ? self.tva : 0,
            image: select.image,
            quantite: 1,
          };

          self.items.push(item);
        } else {
          objExiste.quantite++;
        }
      }
    },
    removeItem: function (index) {
      this.items.splice(index, 1);
    },
    initialise() {
      let self = this;
      this.form.date = self.convertDate(null, null, true, false);

      $("#recherche")
        .autocomplete({
          source: function (request, response) {
            axios
              .get(services.SEARCH_ARTICLE, {
                params: {
                  term: `${request.term}`,
                },
              })
              .then((resp) => {
                response(resp.data.item);
              })
              .catch();
          },
          minLength: 2,
          autoFocus: false,
          delay: 500,
          response: function (event, ui) {
            if (ui.content.length === 1 && ui.content[0].id === 0) {
              $("#recherche").focus();
            } else if (ui.content.length === 1 && ui.content[0].id !== 0) {
              ui.item = ui.content[0];
              $(this)
                .data("ui-autocomplete")
                ._trigger("select", "autocompleteselect", ui);

              $(this).autocomplete("close");
            }
          },
          select: function (event, ui) {
            event.preventDefault();
            if (ui.item.row) {
              self.addItem(ui.item.row);
            }
            $(this).val("");
          },
        })
        .data("ui-autocomplete")._renderItem = function (ul, item) {
        if (item.row) {
          let label = JSON.parse(item.row.designation)[self.locale]
            ? JSON.parse(item.row.designation)[self.locale]
            : "###";
          let reference = item.row.reference ? item.row.reference : "###";
          let marque = item.row.marque ? item.row.marque : "###";
          let codebarre = item.row.codebarre ? item.row.codebarre : "###";

          return $('<div class="list-group mt-2 mb-1"></div>')
            .data("item.autocomplete", item)
            .append(
              '<a href="#" class="list-group-item list-group-item-action flex-column align-items-start">\n' +
                '    <div class="d-flex w-100 justify-content-between">\n' +
                '      <h5 class="mb-1">' +
                label +
                "</h5>\n" +
                "    </div>\n" +
                '    <p class="mb-1">Référence : ' +
                reference +
                ".</p>\n" +
                '    <p class="mb-1">Marque : ' +
                marque +
                ".</p>\n" +
                '    <p class="mb-1">Code barre : ' +
                codebarre +
                ".</p>\n" +
                "  </a>"
            )
            .appendTo(ul);
        }
        return $('<div class="list-group mt-2 mb-1"></div>')
          .data("item.autocomplete", item)
          .append(
            '<a href="#" class="list-group-item list-group-item-action flex-column align-items-start">\n' +
              '    <div class="d-flex w-100 justify-content-between">\n' +
              '      <h5 class="mb-1 text-center">' +
              item.label +
              "</h5>\n" +
              "    </div>\n" +
              "  </a>"
          )
          .appendTo(ul);
      };
    },
    async send(brouillon = false) {
      this.form.brouillon = brouillon;
      let self = this;

      self.errorTableau = false;
      self.errorTableauMessage = "";

      this.form.client = this.user.uuid;
      this.form.itemList = this.items;

      await self.form
        .post(services.STORE)
        .then((data) => {
          self
            .$swal({
              position: "top-end",
              icon: data.data.type,
              text: data.data.message,
              showConfirmButton: false,
              timer: window.Timer,
            })
            .then(function () {
              if (data.data.erreur === false) {
                self.form.reset();

                self.$store.dispatch("cotation/reinitCotation");
                self.$router.push({ name: "shop" });
              }
            });
        })
        .catch((err) => {
          let self = this;
          $.each(err.response.data.errors, function (key, value) {
            if (key.includes("itemList")) {
              self.errorTableau = true;
              self.errorTableauMessage = value[0];
              return false;
            }
          });
        });
    },

    async save() {
      await this.send(true);
    },
  },
  mounted: function () {
    let self = this;
    self.initialise();
    this.$store.dispatch("configapp/getConfig");
  },
};
</script>

<style scoped>
.btn-send {
  padding: 0.5rem 1rem;
  background-color: #caaa73;
  border-radius: 5px;
  font-weight: bold;
}

.btn-send:hover {
  background-color: #b19058;
}

.btn-save {
  padding: 0.5rem 1rem;
  background-color: #333;
  color: #fff;
  border-radius: 5px;
  font-weight: bold;
  margin: 0 0.5rem;
}

.btn-save:hover {
  background-color: #000;
}

.link-all-articles {
  padding: 0.7rem 1rem;
  background-color: rgb(68, 66, 52);
  border-radius: 5px;
  font-weight: bold;
  color: rgb(255, 255, 255);
}

.link-all-articles:hover {
  background-color: #000;
}

.form-control:focus {
  border-color: #f1d198;
  box-shadow: 0 0 0 0.2rem rgba(88, 69, 36, 0.25);
}
</style>
